import axios from 'axios';

export const getEVPlanDetails = async (params) => {
    try {
      const response = await axios.post(process.env.REACT_APP_MW_SMS_API_URL + "/api/subscription/select-plan", params);
  
      if (response.data.statusCode === "1")
        return response.data.data;
      else
        throw new Error(response.data.statusMessage);
  
    } catch (error) {
      return { isError: true, message: error.message };
    }
  }